import { DownloadIcon } from "@primer/octicons-react";
import { useState } from "react";
import axios from "axios";
import { appInfo } from "../../AppInfo";
import Button from "../../component-ui/button";
import { NotifyHelper } from "../../helpers/toast";

interface IDownloadToKhaiXmlButtonProps {
  id: number;
  maToKhai?: string;
  size?: "small" | "medium" | "large";
}

const DownloadToKhaiXmlButton = (props: IDownloadToKhaiXmlButtonProps) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadXml = async () => {
    if (props.id <= 0) return;
    setIsDownloading(true);
    try {
      const response = await axios.get(
        `${appInfo.baseApiURL}/to-khai/${props.id}/xml`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.access_token}`,
            language: localStorage.getItem("language"),
          },
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      const fileName = props.maToKhai
        ? `To-khai-${props.maToKhai}.xml`
        : `To-khai-${props.id}.xml`;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch {
      NotifyHelper.Error("Tải XML tờ khai thất bại");
    }
    setIsDownloading(false);
  };

  return (
    <Button
      text="Tải XML"
      sx={{ mr: 2, minWidth: "100px" }}
      size={props.size ?? "large"}
      variant="invisible"
      leadingVisual={DownloadIcon}
      disabled={props.id <= 0}
      isLoading={isDownloading}
      onClick={handleDownloadXml}
    />
  );
};

export default DownloadToKhaiXmlButton;
